import React, { memo, useContext } from 'react';
import { Grid, TextField } from '@mui/material';
import workFlowStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import { messageDataTempObject } from '../flowBuilderConstants';
import textStyles from './../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss';
import { ChatbotStepActionData, SendWADMTextActionData } from '../../../../models/flowBuilderTypes';
import globalStyles from '../../../../assets/styles/global.module.scss';

const TextVariantNode = ({ id, data }: { id: string, data: ChatbotStepActionData<SendWADMTextActionData> }) => {
    const { setSelectedPointerEvent, setCurrentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const handleClickNewMessage = () => {
        setCurrentActiveNodeConfig((prevstate: any) => ({ ...prevstate, flagOpenConfigForm: true, nodeId: id, data: data, }))
    }


    return (
        <>
            <Grid item className={`${workFlowStyles.messageCardGlobalStyle} ${globalStyles.relativePosition}`} onClick={() => setSelectedPointerEvent(messageDataTempObject.function_name)}>
                <Grid container direction="column" gap="18px">

                    {
                        data?.action_data?.action_text_message_variant_data.map((messages, index: number) => {
                            return index == 0 && <Grid item onClick={() => handleClickNewMessage()} key={index}>
                                <Grid container alignItems={"center"} justifyContent={"center"} flexWrap={"nowrap"}>
                                    <TextField
                                        placeholder='Enter your text...'
                                        className={textStyles.customMessageTextAreaStyle}
                                        multiline
                                        disabled
                                        value={messages.action_text_message_value}
                                    />

                                </Grid>
                            </Grid>
                        })
                    }

                </Grid>
            </Grid>
        </>
    );
};

export default memo(TextVariantNode);